export default "__VITE_ASSET__DIQIae2k__"